/**
 * streamOverlays — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {WIDE, tagline, chips, type ToilePack} from './data'

export const streamOverlaysPack: ToilePack = {
    slug: 'stream-overlays',
    category: 'overlay',
    name: 'Stream overlays',
    tagline: tagline('layouts', 'screens', 'styles'),
    chips: chips('screens', 'styles'),
    ratio: WIDE,
    readings: [
        {key: 'starting', label: 'Starting soon', subject: 'a starting-soon screen, a centered panel and a countdown strip'},
        {key: 'frame', label: 'In-game frame', subject: 'an in-game frame, an empty webcam box, chat column and handle bar'},
        {key: 'offline', label: 'Offline banner', subject: 'an offline banner, a central plate and three social badges'},
    ],
    styles: [
        {key: 'neon', label: 'Neon cyber', style: 'neon cyber, thin light lines', palette: 'magenta and cyan glow on near-black', framing: '16:9 layout, empty placeholder panels'},
        {key: 'lofi', label: 'Cozy lofi', style: 'cozy lofi, soft rounded shapes and plants', palette: 'warm muted browns and creams', framing: '16:9 layout, empty placeholder panels'},
        {key: 'esports', label: 'Clean esports', style: 'clean esports, sharp angular shapes', palette: 'deep navy with one bright accent', framing: '16:9 layout, empty placeholder panels'},
    ],
    directions: ['for a cooking stream', 'in green and cream', 'fewer panels, more open space'],
}
